import { render, staticRenderFns } from "./on.vue?vue&type=template&id=19c62b32"
import script from "./on.vue?vue&type=script&lang=js"
export * from "./on.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports